var PES = PES || {};
PES.AddToBasket = function () {

    var init = function () {
        $(".add-to-basket > .jq-pick-up").on("click",
            function (e) {
                var paymentIntentCheckUrl = window.location.origin + "/user-has-payment-intent";
                $('.btn.btn--big').attr("disabled", true);
                var btn = this;
                var loadingAnimation = $(btn).attr('data-loading-text');
                $.ajax({
                    cache: false,
                    url: paymentIntentCheckUrl,
                    type: "get",
                    contentType: "application/json",
                    success: function (result) {
                        if (!result.HasPaymentIntent) {
                            $(btn).html(loadingAnimation);
                            var trackingData = $(btn).data('tracking');
                            var quantityElement = $(btn).parents(".product-box").find(".qty-input");
                            var quantity = quantityElement.data("quantity");
                            PES.GATracking.AddToBasket(trackingData.name, trackingData.id, trackingData.price, quantity);
                            $(btn).parent("form.add-to-basket").submit();
                        } else {
                            $('.btn.btn--big').attr("disabled", false);
                            $('.modal--payment-intent').showModal();
                            e.preventDefault();
                            e.stopPropagation();
                            return false;
                        }
                    }
                });
                e.preventDefault();
            });
    }

    return {
        init: init
    };
}();